import {generateSearchId} from '@findhotel/sapi'
import {RootState} from 'store'

import {
  getOrGenerateAnonymousId,
  persistAnonymousId,
  removeAnonymousIdFromUrl
} from '@vio/core/src/_web/anonymousId'
import {
  getBrandCodeFromUrlOrCookie,
  getSubBrandKeyFromUrl
} from '@vio/core/src/_web/brand/utils'
import {getPersistedUserCity} from '@vio/core/src/_web/userConfig/userCity'
import {getPersistedUserCountryCode} from '@vio/core/src/_web/userConfig/userCountry'
import {getCookie} from '@vio/core/src/_web/utils/cookies'
import {getQueryStringObject} from '@vio/core/src/_web/utils/url'
import {
  getDeviceCategory,
  getUserDeviceDetails
} from '@vio/core/src/_web/utils/userAgent'
// eslint-disable-next-line @vio/custom-rules/prefer-usebrand-hook -- Needed for augmentMetaState to get brand object from brandCode for subBrand resolution
import {getBrandByCode} from '@vio/core/src/brand/config'
import {defaultLanguage} from '@vio/core/src/localization/services/locale'

import {MetaState} from './slice'

export const augmentMetaState = (
  initialState: Partial<RootState>
): MetaState => {
  const anonymousId = getOrGenerateAnonymousId()
  persistAnonymousId(anonymousId)
  removeAnonymousIdFromUrl()

  const userCountry = getPersistedUserCountryCode()
  const userCity = getPersistedUserCity()
  const {searchId, locale, deviceType, currency} = getQueryStringObject() as {
    searchId: MetaState['searchId']
    locale: MetaState['locale']
    deviceType: MetaState['deviceType']
    currency: MetaState['currency']
  }

  const env = process.env.NEXT_PUBLIC_ENV
  const brandCode = getBrandCodeFromUrlOrCookie(env)
  const brand = getBrandByCode(brandCode)
  const subBrand = getSubBrandKeyFromUrl(brand)
  const {devicePlatform} = getUserDeviceDetails()

  return {
    brandCode,
    subBrand,
    searchId: searchId || generateSearchId(),
    anonymousId,
    userCountry,
    userCity,
    devicePlatform,
    deviceType: deviceType || getDeviceCategory(),
    locale: locale || getCookie('locale') || defaultLanguage,
    currency: currency || getCookie('currency'),
    queryString: new URLSearchParams(location.search).toString(),
    isVioFlutter: false,
    // Allow tests to overwrite initial state
    ...(initialState?.meta || {})
  }
}

export {default} from './slice'
